import {makeStyles} from "@material-ui/core/styles";
import Modal from "../generales/ModalCerrarActualiza";
import {useEffect, useState, useContext} from "react";
import {Box , Button, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography} from "@material-ui/core";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken, llamaApiFormDat3,llamadaApiToken} from "../funciones/ClienteAxios";
import {  DatePicker,    MuiPickersUtilsProvider,} from '@material-ui/pickers';
import {toast} from "react-toastify";
import { useHistory } from "react-router-dom";
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from "axios";
import Reporte from './Reporte'
import moment from 'moment';
import { obtenDispo } from '../funciones/IdDispositivo';
import Progress from "../generales/Progress";
import SearchIcon from '@material-ui/icons/Search';
import { authUser } from '../funciones/AuthUser'
const useStyles = makeStyles((theme) => ({}));


const ReporteAvance = ({}) => {
    let history = useHistory();    
    const classes = useStyles();
    const source = axios.CancelToken.source();
    const fechDia=moment(new Date()).format("YYYY-MM-DD");
    const usuId =localStorage.getItem('UsuId') ; 
    const usuNom =localStorage.getItem('UsuarioNom') ; 
    const auxEdo=process.env.REACT_APP_EDO
    const auxDispV =obtenDispo() 
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const {generales,guardarGenerales}= useContext(GeneralesContext);  
    const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});
    const [btnDeshabilitado, setBotonDeshabilitado] = useState(true)
    const [aviso, setAviso] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [cargando, setCargando] = useState(false);
    const [cargaData, setCargaData] = useState(false);
    const[espera,setEspera]= useState(false);    
    const [data, setData] = useState([]);
    const [archivo,setArchivo]=useState(null);
    const [progresoEnvio, setProgresoEnvio] = useState(0);
    const [nomIniciales, setNomIniciales] = useState("");
    const [listReporte, setListReporte] = useState([]);
    const [listCarta, setListCarta] = useState([]);
    useEffect(() => { 
     
        veriSesion()
           return ()=> {
            source.cancel();
        }  
    }, [])
    const veriSesion =  () => {            
        const auxValidacion=authUser()            
        if(!auxValidacion )
        {  
            guardarUsuario([])				
            guardarGenerales([])    
            localStorage.clear();            	             
            history.push("/")	                	
        }
        else
        {   const usu= localStorage.getItem('UsuarioNom');
              const nvl= localStorage.getItem('Tipo') ? parseInt( localStorage.getItem('Tipo') ):0 ;       
            if (usuario.length==0) 
            {   guardarUsuario({Nombre:usu,nivel:nvl});                                                             
            }                                                      
            guardarGenerales({...generales,Titulo:'Reporte Avance'})   
            
            if (usuId !== null && usuId !== undefined  ) 
            {     
                getList()                                                                                          
            }
            else
            {   localStorage.clear();                            
                history.push("/");  
            }              
        }            
    }    
  
    function getList()  {            
        const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
        const fFinal=moment(fSelect.final).format("YYYY-MM-DD");  
        const url= `perfil/v1/adm/report/avance`;                            
        const data = qs.stringify({                
         
            Usuario:usuId,
            FIni:`${fInicio}T00:00:00`,
            FFin:`${fFinal}T23:59:59`,                                                             
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux) 
            {  
                setListReporte(aux)                      
            }  
            else
            {   setListReporte([])
            }                                                                    
        }
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    }; 
    const guardarInicio = auxfecha =>
    {
        setFSelect({
        ...fSelect,
        inicio : auxfecha  
        })
    };
    const guardarFinal = auxfecha =>
    {
        setFSelect({
        ...fSelect,
        final : auxfecha  
        })
    };
    
    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;        
          
        if( (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                             
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }
    const mandaAlerta=(mensaje,tipoAdvert)=>
        {
            setMensaje(mensaje);
            setTipoAdvertencia(tipoAdvert)  
            setAviso(true);      
        }
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta(`Campo ${auxMensaje} incompleto, debe escribir un Contenido \nminimo de 10 caracteres.`,"warning") 
            }
        }        
        return respuesta;
    }

    return (
     <Box display="flex" flexDirection={"row"}>
        <Box  alignItems={'center'} spacing={1} style={{width:"20%", marginRight:"2rem"}}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>    
                <Box component="span"  display={"flex"} flexDirection={"column"}>
                <Box   component="span" width={1/4}>                                                
                    <DatePicker
                        disableFuture format="dd/MM/yyyy"
                        views={["year", "month", "date"]}
                        label="Fecha Inicial" size="small"
                        minDate="2021-12-31" maxDate={new Date()}
                        value={fSelect.inicio} onChange={guardarInicio}      
                        style={{width:6.5+'rem'}}     
                        cancelLabel={"Cancelar"}                  
                        okLabel="Seleccionar"     
                    />
                </Box>    
                <Box component="span" width="25%">
                    <DatePicker
                        disableFuture id="final"
                        format="dd/MM/yyyy" label="Fecha Final"
                        views={["year", "month", "date"]}
                        minDate={fSelect.inicio} maxDate={new Date()}
                        value={fSelect.final} name="final"
                        size="small" style={{width:6.5+'rem'}}      
                        cancelLabel={"Cancelar"}                  
                        okLabel="Seleccionar"    
                        onChange={guardarFinal}
                        minDateMessage={"La fecha final debe ser menor a Fecha inicial"}
                    />
                </Box> 
                </Box>                         
            </MuiPickersUtilsProvider>
            <Button onClick={getList} style={{width:"7rem", marginTop:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
                Buscar     
            </Button>     
        </Box>
        <Box  display="flex" style={{ width:"80%" }}>
            { !espera&& listReporte.length!==0 ?
           <Box  style={{ height:"100%", width:"100%" }} >
               
                <Reporte urlReport={"./reports/RepEncAvance250916.mrt"} informacion={listReporte} nombre={`Reporte_de_Avance_`} mostrarTB={true} 
                    setArchivo={setArchivo}
                />               
            </Box>
            
            : (espera ? null : <Box width={"20rem"} style={{marginTop:"1rem"}}><LinearProgress/></Box>) }
        </Box>
        </Box>)
  
};

export default ReporteAvance;
